import { render, staticRenderFns } from "./MyWalletDisclaimerMobile.vue?vue&type=template&id=68fd288c"
import script from "./MyWalletDisclaimerMobile.vue?vue&type=script&lang=ts"
export * from "./MyWalletDisclaimerMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports